import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import WidgetWithIcon from '../WidgetWithIcon/WidgetWithIcon';

import {
  getFullName,
  moneyFormater,
  textToDate,
  getInitials
} from 'utils/common';
import { displayPaymentMethods } from '../../helpers/helpers';

import classes from './Widgets.module.scss';

const Widgets = ({ widgets }) => {
  const { t } = useTranslation('activity');
  const { contact, collection } = widgets;

  const listContact = {
    titleWidget: t('activity:contacts.CONTACT_PERSON'),
    initials: getInitials(contact.firstName, contact.lastName),
    info: [
      {
        title: `${t('activity:contacts.NAME')}:`,
        value: getFullName(contact.firstName, contact.lastName)
      },
      {
        title: `${t('activity:contacts.ROLE')}:`,
        value: contact.role ? contact.role : 'NA'
      },
      {
        title: `${t('activity:contacts.EMAIL')}:`,
        value: contact.email ? contact.email : 'NA',
        type: 'mail',
        textLink: t('activity:contacts.CONTACT_PERSON')
      },
      {
        title: `${t('activity:contacts.WORK_PHONE')}:`,
        value: contact.workPhone ? contact.workPhone : 'NA',
        hiddenIfvalueMissing: true
      },
      {
        title: `${t('activity:contacts.MOBILE')}:`,
        value: contact.phone ? contact.phone : 'NA',
        hiddenIfvalueMissing: true
      },
      {
        title: `${t('activity:contacts.LINKEDIN')}:`,
        value: contact.linkedin ? contact.linkedin : 'NA',
        type: 'link',
        textLink: t('activity:contacts.GO_TO_PAGE'),
        hiddenIfvalueMissing: true
      }
    ]
  };

  const listCollection = {
    titleWidget: t('activity:collection.COLLECTION'),
    icon: 'salesLead',
    info: [
      {
        title: `${t('activity:collection.BALANCE')}:`,
        value: moneyFormater(collection.balance)
      },
      {
        title: `${t('activity:customers.ARR')}:`,
        value: moneyFormater(collection.arr)
      },
      {
        title: `${t('activity:customers.BILLING_CYCLE')}:`,
        value: collection.billingCycle ? collection.billingCycle : 'NA'
      },
      {
        title: `${t('activity:filters.FIRST_PAYMENT')}:`,
        value:
          collection.firstPayment &&
          collection.firstPayment !== '-' &&
          collection.firstPayment !== 'NA' &&
          collection.firstPayment !== '1970-01-01T00:00:00.000Z'
            ? textToDate(collection.firstPayment)
            : 'NA'
      },
      {
        title: `${t('activity:collection.NEXT_PAYMENT')}:`,
        value:
          collection.nextPayment &&
          collection.nextPayment !== '-' &&
          collection.nextPayment !== 'NA' &&
          collection.nextPayment !== '1970-01-01T00:00:00.000Z'
            ? textToDate(collection.nextPayment)
            : 'NA'
      },
      {
        title: `${t('activity:filters.PAYMENT_METHOD')}:`,
        value:
          collection.paymentMethods && collection.paymentMethods.length > 0
            ? displayPaymentMethods(collection.paymentMethods)
            : 'NA'
      },
      {
        title: `${t('activity:filters.PAYMENT_TERMS')}:`,
        value: 'Net' + collection.paymentTerms.netTermDays
      }
    ]
  };

  return (
    <div className={classes.box_wrap}>
      <WidgetWithIcon data={listCollection} />
      <WidgetWithIcon data={listContact} />
    </div>
  );
};

Widgets.propTypes = {
  widgets: PropTypes.object
};

export default Widgets;
